var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoAgregarAlianza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 66,
    viewBox: "0 0 82 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 25H43V31.375C43 36.125 39.5 40.375 34.875 40.875C29.5 41.5 25 37.25 25 32V16.875L21.875 18.75C16.375 22 13 28 13 34.5L3 40.25C1 41.375 0.375 43.875 1.5 45.75L11.5 63.125C12.625 65 15 65.625 17 64.5L29.875 57.125H47C51.375 57.125 55 53.5 55 49.125C58.25 49.125 61 46.375 61 43.125V37H62C63.625 37 65 35.75 65 34V28C65 26.375 63.625 25 62 25ZM80.375 20.375L70.375 3C69.25 1.125 66.875 0.5 65 1.625L52 9H44.25C39.5 9 34.875 10.375 30.75 12.875C29.625 13.625 29 14.875 29 16.25V32C29 34.875 31.125 37 34 37C36.75 37 39 34.875 39 32V21H62C65.75 21 69 24.125 69 28V31.5L79 25.75C80.875 24.75 81.5 22.25 80.375 20.375Z",
    fill: "#F0F0EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAgregarAlianza);
export default __webpack_public_path__ + "static/media/icono_agregarAlianza.47bab3e3cdd9b4bbce01a8db3baf90f1.svg";
export { ForwardRef as ReactComponent };